(function () {
  function escParchesInit(root) {
    var sectionId = root.dataset.sectionId;
    var productTitle = root.dataset.productTitle || '';
    var variantTitle = root.dataset.variantTitle || '';
    // La talla se lee al enviar: ya no viene preseleccionada, así que la del render no sirve.
    function targetLabelNow() {
      var checked = document.querySelector('[data-esc-talla-req] input[type="radio"]:checked');
      var talla = checked ? checked.value : variantTitle;
      return talla && talla !== 'Default Title' ? productTitle + ' — Talla ' + talla : productTitle;
    }

    var checkboxes = root.querySelectorAll('.esc-parches__checkbox');
    var customEl = document.getElementById('esc-parches-custom-' + sectionId);
    var rowsEl = document.getElementById('esc-parches-custom-rows-' + sectionId);
    var addBtn = document.getElementById('esc-parches-add-' + sectionId);
    var rowTemplate = document.getElementById('esc-parches-row-template-' + sectionId);
    var totalEl = document.getElementById('esc-parches-total-' + sectionId);
    var submitBtn = document.getElementById('esc-parches-submit-' + sectionId);
    var statusEl = document.getElementById('esc-parches-status-' + sectionId);

    var customVariantId = customEl ? parseInt(customEl.dataset.variantId, 10) : null;
    var customPrice = customEl ? parseInt(customEl.dataset.price, 10) : 0;

    function moneyFormat(cents) {
      var value = Math.round(cents / 100);
      return '$' + value.toLocaleString('es-CO');
    }

    function customRows() {
      return rowsEl ? Array.prototype.slice.call(rowsEl.querySelectorAll('.esc-parches__custom-row')) : [];
    }

    function filledCustomRows() {
      return customRows().filter(function (row) {
        var text = row.querySelector('.esc-parches__custom-text');
        return text && text.value.trim().length > 0;
      });
    }

    function recalcTotal() {
      var total = 0;
      checkboxes.forEach(function (cb) {
        if (cb.checked) total += parseInt(cb.dataset.price, 10) || 0;
      });
      total += filledCustomRows().length * customPrice;

      if (totalEl) totalEl.textContent = moneyFormat(total);
      if (submitBtn) submitBtn.disabled = total === 0;
    }

    function addCustomRow() {
      if (!rowTemplate || !rowsEl) return;
      var node = rowTemplate.content.firstElementChild.cloneNode(true);
      var textInput = node.querySelector('.esc-parches__custom-text');
      var removeBtn = node.querySelector('.esc-parches__remove-btn');
      textInput.addEventListener('input', recalcTotal);
      removeBtn.addEventListener('click', function () {
        node.remove();
        recalcTotal();
      });
      rowsEl.appendChild(node);
      textInput.focus();
    }

    checkboxes.forEach(function (cb) {
      cb.addEventListener('change', recalcTotal);
    });

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        addCustomRow();
        recalcTotal();
      });
    }

    function addStructuredPatches() {
      var items = [];
      checkboxes.forEach(function (cb) {
        if (cb.checked) {
          items.push({
            id: parseInt(cb.value, 10),
            quantity: 1,
            properties: {
              Parche: cb.dataset.title,
              'Para la camiseta': targetLabelNow(),
            },
          });
        }
      });
      if (!items.length) return Promise.resolve();
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items }),
      }).then(function (res) {
        if (!res.ok) throw new Error('No se pudo añadir el parche.');
      });
    }

    function addCustomRowToCart(row) {
      var text = row.querySelector('.esc-parches__custom-text').value.trim();
      var fileInput = row.querySelector('.esc-parches__custom-file');
      var formData = new FormData();
      formData.append('id', customVariantId);
      formData.append('quantity', '1');
      formData.append('properties[Descripción del parche]', text);
      formData.append('properties[Para la camiseta]', targetLabelNow());
      if (fileInput && fileInput.files && fileInput.files[0]) {
        formData.append('properties[Imagen de referencia]', fileInput.files[0]);
      }
      return fetch('/cart/add', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData,
      }).then(function (res) {
        if (!res.ok) throw new Error('No se pudo añadir un parche personalizado.');
      });
    }

    function addCustomPatches() {
      var rows = filledCustomRows();
      var chain = Promise.resolve();
      rows.forEach(function (row) {
        chain = chain.then(function () {
          return addCustomRowToCart(row);
        });
      });
      return chain;
    }

    if (submitBtn) {
      submitBtn.addEventListener('click', function () {
        submitBtn.disabled = true;
        if (statusEl) statusEl.textContent = 'Añadiendo parches al carrito…';

        addStructuredPatches()
          .then(addCustomPatches)
          .then(function () {
            if (statusEl) {
              statusEl.innerHTML = 'Parches añadidos. <a href="/cart">Ver carrito</a>';
            }
            checkboxes.forEach(function (cb) {
              cb.checked = false;
            });
            customRows().forEach(function (row) {
              row.remove();
            });
            recalcTotal();
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          })
          .catch(function (err) {
            if (statusEl) statusEl.textContent = err.message || 'Ocurrió un error, intenta de nuevo.';
            recalcTotal();
          });
      });
    }

    /*
     * Oct 2026: antes los parches marcados se perdían si el cliente pulsaba "Agregar al
     * carrito" (solo entraban con el botón aparte). Ahora se interceptan en el envío del
     * formulario principal: se agregan primero los parches y luego sigue el flujo normal
     * (personalización + camiseta). Se escucha en "document" y en captura para correr
     * ANTES que esc-personalization.js, que escucha en el propio formulario.
     */
    var form = document.querySelector('form[data-type="add-to-cart-form"]');
    var hayParches = function () {
      return Array.prototype.some.call(checkboxes, function (cb) { return cb.checked; }) || filledCustomRows().length > 0;
    };
    if (form) {
      document.addEventListener('submit', function (e) {
        if (e.target !== form || !hayParches()) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        if (statusEl) statusEl.textContent = 'Agregando tus parches…';
        addStructuredPatches()
          .then(addCustomPatches)
          .then(function () {
            checkboxes.forEach(function (cb) {
              cb.checked = false;
              cb.dispatchEvent(new Event('change', { bubbles: true }));
            });
            customRows().forEach(function (row) { row.remove(); });
            recalcTotal();
            if (statusEl) statusEl.textContent = '';
            form.requestSubmit();
          })
          .catch(function (err) {
            if (statusEl) statusEl.textContent = (err && err.message) || 'No se pudieron agregar los parches. Intenta de nuevo.';
          });
      }, true);
    }

    recalcTotal();
  }

  function escParchesBoot() {
    document.querySelectorAll('.esc-parches').forEach(escParchesInit);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', escParchesBoot);
  } else {
    escParchesBoot();
  }
})();
